import { APP_CDT_RETURN_STORAGE_PREFIX, APP_CDT_SCHEME } from './constants'

export * from './constants'

export function buildAppCdtDeepLink(linkId: string) {
  return `${APP_CDT_SCHEME}?linkId=${encodeURIComponent(linkId)}`
}

export function isMobileDevice() {
  if (typeof navigator === 'undefined') {
    return false
  }

  const userAgent = navigator.userAgent || ''

  if (/Android|iPhone|iPod/i.test(userAgent)) {
    return true
  }

  const isIpad =
    /iPad/i.test(userAgent) ||
    (/Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1)

  return isIpad
}

const returnStorageKey = (linkId: string) =>
  `${APP_CDT_RETURN_STORAGE_PREFIX}:${linkId}`

export function markReturnFromAppCdt(linkId: string) {
  try {
    window.sessionStorage.setItem(returnStorageKey(linkId), 'true')
  } catch {
    return
  }
}

export function hasReturnedFromAppCdt(linkId: string) {
  try {
    return window.sessionStorage.getItem(returnStorageKey(linkId)) === 'true'
  } catch {
    return false
  }
}

export function clearReturnFromAppCdt(linkId: string) {
  try {
    window.sessionStorage.removeItem(returnStorageKey(linkId))
  } catch {
    return
  }
}
